/* eslint-disable no-unused-vars */
import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SectionLayout from 'components/common/SectionLayout';
import { generalActions } from 'store/campaign/general';
import SelectedApps from './selectedAppsSection/SelectedApps';
import { selectTargetType } from 'store/selectors';
import { RadioBox, Label } from 'components';
import { elementIsDisabled } from 'utils';
import { RadioBoxGroup, RightSideContainer } from '../components';

const TargetingOngoingPlacementsDirectBuy = ({ environment }) => {
  const dispatch = useDispatch();
  const targetType = useSelector(selectTargetType) || 2;
  const current_selected_apps = useSelector(
    (store) => store?.general?.mainCampaignObject?.currently_selected_apps,
  );

  const handleChange = useCallback(
    (newValue) => {
      if (newValue === targetType) return;
      if (current_selected_apps.length) {
        dispatch(generalActions.clear_currently_selected_apps());
      }
      dispatch(
        generalActions.updateCurrentCampaignObj({
          propField: 'target_type',
          newValue: Number(newValue),
        }),
      );
      dispatch(generalActions.setMinBidAsNotRelevant());
    },
    [targetType, current_selected_apps],
  );

  return (
    <SectionLayout
      noBottomPadding={true}
      leftSide={<Label text='Placements:' variant='label' style={{ marginTop: '8px' }} />}
      rightSide={
        <RightSideContainer>
          <RadioBoxGroup>
            <RadioBox.NormalSize
              onChange={handleChange}
              label='All Placements'
              width={142}
              variant='left'
              value={1}
              pressed={+targetType === 1}
              disabled={elementIsDisabled(environment, +targetType === 1)}
            />
            <RadioBox.NormalSize
              onChange={handleChange}
              label='Direct Buy'
              width={112}
              variant='right'
              value={2}
              pressed={+targetType === 2}
              disabled={elementIsDisabled(environment, +targetType === 2)}
            />
          </RadioBoxGroup>
          {targetType == 2 && (
            <SelectedApps
              isAllPlacementsDisabled={elementIsDisabled(environment, +targetType === 1)}
            />
          )}
        </RightSideContainer>
      }
    />
  );
};

export default memo(TargetingOngoingPlacementsDirectBuy);
